import React, { FC, useMemo } from 'react'

import { IconButton } from '../../IconButton'
import { FavoriteIcon } from '../FavoriteIcon'

import eBalanceLogo from './eBalance-logo.png'

import { IconColor, IconName } from 'Components/Icon'
import { EatableSource, ImageUrl } from 'Models'
import { Formatter } from 'Utils'

interface Props {
  imageUrl?: ImageUrl
  energy: number
  isFavorite?: boolean
  source?: EatableSource | null
  portionAmount?: number
  onFavoriteChange?: (value: boolean) => void
  onClose?: () => void
  onPrint?: () => void
  extension: string
}

const DetailCardHeader: FC<Props> = ({
  energy,
  imageUrl,
  isFavorite = false,
  onClose,
  onFavoriteChange,
  onPrint,
  source,
  portionAmount,
  extension
}: Props) => {
  const portionLabel = useMemo(() => {
    return portionAmount ? `${Formatter.formatFoodAmount(portionAmount, 'GRAM')} ${extension}` : ''
  }, [portionAmount, extension])

  const energyLabel = useMemo(() => {
    return `${Formatter.formatEnergy(energy)} ${extension}`
  }, [energy, extension])

  const imageUrlWithQuality = imageUrl ? `${imageUrl}&quality=70&format=jpg&strip=1` : undefined

  return (
    <>
      <div className="hiddenInPrint detailcard-img">
        {imageUrl && <img src={imageUrlWithQuality} />}
        <div className="detailcard-img-kcal">
          {energyLabel}
          <br />
          {portionLabel}
        </div>
      </div>

      {imageUrl && (
        <div className="hiddenOnScreen detailcard-img">
          <img src={imageUrlWithQuality} />
          <div className="detailcard-img-kcal">
            {energyLabel}
            <br />
            {portionLabel}
          </div>
        </div>
      )}

      {!imageUrl && (
        <div className="hiddenOnScreen pt-3 pl-5 text-small">
          {energyLabel}
          <br />
          {portionLabel}
        </div>
      )}

      <div className="detailcard-actions-left hiddenInPrint">
        <FavoriteIcon isFavorite={isFavorite} onChange={onFavoriteChange} />

        {onPrint && (
          <IconButton
            name={IconName.print}
            color={IconColor.WHITE}
            onClick={onPrint}
            linkTitle="Drucken"
            hiddenInPrint
          />
        )}
      </div>

      <IconButton
        name={IconName.close}
        color={IconColor.WHITE}
        onClick={onClose}
        hiddenInPrint={true}
        linkTitle="Schliessen"
      />

      <img src={eBalanceLogo} className="hiddenOnScreen ebalance-logo" />

      {source && source.imageUrl && (
        <div className="detailcard-logo">
          <img src={source.imageUrl} />
        </div>
      )}
    </>
  )
}

export default DetailCardHeader
